import { createActions, createReducer } from "reduxsauce";

import { merge } from "utils/object";

export const { Types, Creators } = createActions({
    updateFilters: ["payload"],
    setModal: ["payload"],
    updateTotals: ["payload"],
    updatePrazo: ["payload"],
    setOccurrences: ["payload"],
    updateRomaneios: ["payload"],
    updateList: ["payload"],
    updateListAnalitico: ["payload"],
    updateViewing: ["payload"],
    updateRequests: ["payload"],
    setModalSubNivel: ["payload"],
});

export const PRAZO_TYPES = {
    prazo: {
        value: 'prazo',
        label: 'Prazo'
    },
    prazo_operacional: {
        value: 'prazo_operacional',
        label: 'Prazo Operacional'
    },
    prazo_cte: {
        value: 'prazo_cte',
        label: 'Prazo CTe'
    },
    prazo_coleta: {
        value: 'prazo_coleta',
        label: 'Prazo Romaneio de Coleta'
    }
};

export const INITIAL_STATE = {
    filters: {
        loading: true,
        title: "Geral",
        back: null,
        search: "romaneio",
        type: "operacional",
        grouping: "romaneio",
        groupingAnalitic: "remetente",
        tipo: true,
        filter: {
            classificacao: "NORMAL",
        },
    },
    prazoType: PRAZO_TYPES.prazo.value,
    rom: "",
    romRequest: {},
    modal: null,
    request: false,
    totals: {
        total: {
            total: 0,
            compro: 0,
            abertos: 0,
            porcent: 0,
        },
        comprovados: {
            entrega: 0,
            outras: 0,
            auditoria: 0,
        },
        abertos: {
            sem_rom: 0,
            expedicao: 0,
            rota: 0,
        },
        prazo: {
            dentro: 0,
            fora: 0,
            desempenho: 0,
        },
    },
    occurrences: [
        {
            id: "@ocorrencias/no_information",
            title: "Sem informações",
            value: 0,
            percentage: 100,
            color: "#E9ECEF",
        },
    ],
    romaneios: {
        total: 0,
        viagem: 0,
        expedicao: 0,
        concluidos: 0,
    },
    list: {
        loading: false,
        searchBy: null,
        orderBy: null,
        orderByControl: { label: "desc", value: -1 },
        rowsPerPage: 50,
        page: 0,
        totalPages: 0,
        total: 0,
        fields: {},
        data: [],
        inicial: {},
    },
    listAnalitico: {
        loading: false,
        searchBy: null,
        orderBy: null,
        orderByControl: { label: "asc", value: 1 },
        rowsPerPage: 50,
        page: 0,
        totalPages: 0,
        total: 0,
        fields: {},
        data: [],
        inicial: {},
    },
    viewing: {},
    requests: {
        loading: false,
        filters: null,
        grouping: null,
        documents: null,
    },
};

const updateFilters = (state = INITIAL_STATE, action) => ({
    ...state,
    filters: {
        ...state.filters,
        ...action.payload,
    },
});

const setModal = (state = INITIAL_STATE, action) => {

    return ({
        ...state,
        modal: action.payload,
        request: false,
    })
};

const setModalSubNivel = (state = INITIAL_STATE, action) => {
    let payload = action.payload;
    return {
        ...state,
        modal: payload.modal,
        request: true,
        rom: payload.rom,
        romRequest: payload.romRequest,
    };
};

const updateTotals = (state = INITIAL_STATE, action) => {
    const mergedStates = merge(state.totals, action.payload)
    const totalsAzp = action?.payload?.totalsAzp

    return ({
        ...state,
        totals: { ...mergedStates, totalsAzp: totalsAzp || state?.totals?.totalsAzp || {} },
    })
};

const updatePrazo = (state = INITIAL_STATE, action) => ({
    ...state,
    prazoType: action.payload
})

const setOccurrences = (state = INITIAL_STATE, action) => ({
    ...state,
    occurrences: action.payload,
});

const updateRomaneios = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneios: { ...state.romaneios, ...action.payload },
});

const updateList = (state = INITIAL_STATE, action) => {
    let fields = {},
        inicial = {};
    if (action.payload.fields === undefined) {
        fields = state.list.fields;
        inicial = state.list.inicial;
    } else {
        fields = action.payload.fields;
        inicial = action.payload.inicial;
    }

    return {
        ...state,
        list: {
            ...merge(state.list, action.payload),
            fields: fields,
            inicial: inicial,
        },
    };
};

const updateListAnalitico = (state = INITIAL_STATE, action) => {
    let fields = {},
        inicial = {};
    if (action.payload.fields === undefined) {
        fields = state.listAnalitico.fields;
        inicial = state.listAnalitico.inicial;
    } else {
        fields = action.payload.fields;
        inicial = action.payload.inicial;
    }

    return {
        ...state,
        listAnalitico: {
            ...merge(state.listAnalitico, action.payload),
            fields: fields,
            inicial: inicial,
        },
    };
};

const updateViewing = (state = INITIAL_STATE, action) => {

    return ({
        ...state,
        viewing: {
            ...state.viewing,
            ...action.payload,
        },
    })
};

const updateRequests = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        requests: {
            ...state.requests,
            ...action.payload,
        },
    };
};

export default createReducer(INITIAL_STATE, {
    [Types.UPDATE_FILTERS]: updateFilters,
    [Types.SET_MODAL]: setModal,
    [Types.UPDATE_TOTALS]: updateTotals,
    [Types.UPDATE_PRAZO]: updatePrazo,
    [Types.SET_OCCURRENCES]: setOccurrences,
    [Types.UPDATE_ROMANEIOS]: updateRomaneios,
    [Types.UPDATE_LIST]: updateList,
    [Types.UPDATE_LIST_ANALITICO]: updateListAnalitico,
    [Types.UPDATE_VIEWING]: updateViewing,
    [Types.UPDATE_REQUESTS]: updateRequests,
    [Types.SET_MODAL_SUB_NIVEL]: setModalSubNivel,
});
